import Utils from "./utils";

class i18n extends Utils {
  static t(key) {
    return this.store().data.i18n.getIn(key.split("."));
  }
}

export default i18n;
